import { render } from "./PriceTrackReport.vue?vue&type=template&id=40b3b1e6&ts=true"
import script from "./PriceTrackReport.vue?vue&type=script&lang=ts"
export * from "./PriceTrackReport.vue?vue&type=script&lang=ts"

import "./PriceTrackReport.vue?vue&type=style&index=0&id=40b3b1e6&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__